module.exports = __webpack_public_path__ + "static/media/image_404.09893593.jpg";